import { NUMBERS } from "../content";
import { Counter, Reveal } from "../lib/motion";

export const Numbers = () => (
  <section
    data-testid="numbers-strip"
    aria-label="Números da DealFlow Lab"
    className="relative bg-tinta overflow-hidden"
  >
    <div
      className="absolute -right-16 -top-10 w-72 h-24 bg-lima"
      style={{ clipPath: "polygon(18% 0, 100% 0, 82% 100%, 0 100%)", transform: "rotate(-8deg)" }}
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-24 relative">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {NUMBERS.map((n, i) => (
          <Reveal
            key={n.label}
            delay={i * 0.1}
            className={`py-8 sm:py-6 lg:py-2 sm:px-8 ${
              i > 0 ? "border-t sm:border-t-0 sm:border-l border-inkline" : ""
            } ${i % 2 === 1 ? "sm:border-l" : ""} ${i >= 2 ? "sm:border-t lg:border-t-0" : ""}`}
          >
            <div
              data-testid={`number-value-${i}`}
              className={`headline text-creme ${
                n.custom
                  ? "text-[22px] sm:text-3xl lg:text-[30px] lg:whitespace-nowrap xl:text-4xl"
                  : "text-4xl md:text-5xl lg:text-[44px] xl:text-5xl whitespace-nowrap"
              }`}
            >
              {n.custom ? (
                n.custom
              ) : (
                <>
                  {n.prefix.startsWith("+") && <span className="text-lima">+</span>}
                  <Counter
                    value={n.value}
                    prefix={n.prefix.replace(/^\+/, "")}
                    suffix={n.suffix}
                  />
                </>
              )}
            </div>
            <p className="mt-3 text-sm text-muteddark font-inter">{n.label}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
